import styles from './progress.module.scss';
import MaterialCircularProgress from '@mui/material/CircularProgress';
import MaterialLinearProgress from '@mui/material/LinearProgress';

/* eslint-disable-next-line */
export interface CircularProgressProps {
  // classes?: object,
  color?: | 'inherit' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  // disableShrink?: boolean,
  size?: number | string,
  // sx?: any,
  // thickness?: number,
  //value?: number,
  // variant?: 'determinate' | 'indeterminate',
  className?: string
}

export interface LinearProgressProps {
  // classes?: object,
  color?: 'inherit' | 'primary' | 'secondary',
  // sx?: any,
  value?: number,
  // valueBuffer?: number,
  variant?: 'buffer' | 'determinate' | 'indeterminate' | 'query'
}

export function CircularProgress(props: CircularProgressProps) {
  return (
    <MaterialCircularProgress
      color={props.color}
      className={props.className}
      size={props.size}
    />
  );
}

export function LinearProgress(props: LinearProgressProps) {
  return (
    <MaterialLinearProgress
      color={props.color}
      variant={props.variant}
      value={props.value}
    />
  );
}

export default CircularProgress;